import { useEffect, useState } from 'react';

/**
 * Seconds since the reward was burned. Clamped at 0 so a client clock running
 * behind the server never renders a negative age.
 *
 * Deliberately unbounded. This is a FRESHNESS signal proving a live session —
 * a screenshot cannot tick — not a validity window. The burn is permanent, so
 * a slow barista must never cost a customer their reward. An earlier draft of
 * the design expired the confirmation; that turned a fraud control into a
 * customer-punishment mechanic and was dropped.
 */
export function secondsSince(redeemedAtIso: string, now: number): number {
  return Math.max(0, Math.floor((now - Date.parse(redeemedAtIso)) / 1000));
}

export function useLivenessTicker(redeemedAtIso: string): number {
  const [secs, setSecs] = useState(() => secondsSince(redeemedAtIso, Date.now()));
  useEffect(() => {
    setSecs(secondsSince(redeemedAtIso, Date.now()));
    const id = setInterval(() => setSecs(secondsSince(redeemedAtIso, Date.now())), 1000);
    return () => clearInterval(id);
  }, [redeemedAtIso]);
  return secs;
}
